export default "__VITE_ASSET__CL39pXI2__"